import { Button, Checkbox, FormControlLabel, Paper, TextField, Typography } from "@material-ui/core";
import React from "react";
import "../Main.css";
import { isNullOrEmpty, parseDate } from "../Util";
import { FollowUpsGrid } from "./FollowUpsGrid";
import FollowUpModal from "./FollowUpModal";

export interface FollowUp {
	BuildingName: string;
	FollowUpID: string;
	Address: string;
	Contact1Name: string;
	Contact1Email: string;
	Contact1Phone: string;
	Contact2Name: string;
	Contact2Email: string;
	Contact2Phone: string;
	Contact3Name: string;
	Contact3Email: string;
	Contact3Phone: string;
	DateAssessed?: Date;
	DateContract?: Date;
	DateLastUpdated: Date;
	FollowUps: string;
	Landings: string;
	Lost: boolean;
	Maintenance: boolean;
	Modern: boolean;
	Repair: boolean;
	Notes: string;
	LastNote: string;
}

export function FollowUps() {
	const [fups, setFups] = React.useState([] as Array<FollowUp>);

	const [modalOpen, setModalOpen] = React.useState(false);
	const [modalFup, setModalFup] = React.useState(null as FollowUp);
	const [includeLost, setIncludeLost] = React.useState(false);

	const init = async () => {
		getData(includeLost);
	};

	const getData = (il: boolean) => {
		fetch("Inspection/GetFollowUps", {
			method: "Post",
			headers: {
				"Content-Type": "application/json",
			},
			cache: "no-cache",
			body: JSON.stringify(il),
		})
			.then((x) => x.json())
			.then((x) => {
				const res = x.map((y: any) => {
					const splitNotes = y.follow_ups && y.follow_ups.split("\n");
					return {
						BuildingName: y.building_name,
						Address: y.address,
						Contact1Email: y.contact_1_email,
						Contact1Name: y.contact_1_name,
						Contact1Phone: y.contact_1_phone,
						Contact2Email: y.contact_2_email,
						Contact2Name: y.contact_2_name,
						Contact2Phone: y.contact_2_phone,
						Contact3Email: y.contact_3_email,
						Contact3Name: y.contact_3_name,
						Contact3Phone: y.contact_3_phone,
						DateAssessed: parseDate(y.date_assessed),
						DateContract: parseDate(y.date_contract),
						DateLastUpdated: parseDate(y.date_last_updated),
						FollowUpID: y.follow_up_id,
						FollowUps: y.follow_ups,
						Landings: y.landings,
						Lost: y.lost,
						Maintenance: y.maint,
						Modern: y.modern,
						Notes: y.notes,
						Repair: y.repair,
						LastNote: splitNotes && splitNotes[splitNotes.length - 1],
					} as FollowUp;
				});
				setFups(res);
			});
	};

	const openModalWithRecord = (fup: FollowUp) => {
		setModalFup(fup);
		setModalOpen(true);
	};

	const closeModal = () => {
		setModalOpen(false);
		setModalFup(null);
		getData(includeLost);
	};

	React.useEffect(() => {
		init();
	}, []);

	return (
		<>
			{modalOpen && <FollowUpModal record={modalFup} onClose={closeModal}></FollowUpModal>}
			<div style={{ backgroundColor: "#ebebeb", padding: "4px", flex: 1, display: "flex", flexDirection: "column", maxHeight: "100%" }}>
				<div style={{ flex: "1 1 100%", display: "flex", overflowY: "auto" }}>
					<Paper style={{ flex: 1, overflowY: "auto" }}>
						<Typography variant="h5" style={{ padding: "8px" }}>
							Follow Ups{" "}
							<Button
								variant="contained"
								color="primary"
								onClick={() => {
									setModalOpen(true);
								}}>
								Add New
							</Button>{" "}
							<FormControlLabel
								label="Include Lost?"
								control={
									<Checkbox
										checked={includeLost}
										onChange={(event) => {
											setIncludeLost(event.target.checked);
											getData(event.target.checked);
										}}></Checkbox>
								}
							/>
						</Typography>
						<FollowUpsGrid Data={fups} OpenRow={openModalWithRecord}></FollowUpsGrid>
					</Paper>
				</div>
			</div>
		</>
	);
}
